export enum TractorType {
    Unknown = -1,
    DayCab = 0,
    SleeperCab = 1,
    Yard = 2,
    StraightBox = 3,
    StraightFlat = 4,
    Pickup = 5
}

export const TractorTypeMetadata = {
    '-1': {
        display: 'Unknown',
        value: -1
    },
    '0': {
        display: 'Day Cab',
        value: 0
    },
    '1': {
        display: 'Sleeper',
        value: 1
    },
    '2': {
        display: 'Yard Truck',
        value: 2
    },
    '3': {
        display: 'Straight Box',
        value: 3
    },
    '4': {
        display: 'Straight Flat',
        value: 4
    },
    '5': {
        display: 'Pickup',
        value: 5
    }
};
